import { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  Box,
  ListItemText,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  ListItemButton,
  Stack,
  Link,
  Container,
  Avatar,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Facebook,
  Twitter,
  YouTube,
  Instagram,
  HighlightOff,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { deepOrange } from "@mui/material/colors";

import SainiAudiobookLogo from "../assets/dkaudiobooks.png";

const Navbar = () => {
  const [openSearch, setOpenSearch] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleSearchOpenState = (bool) => {
    setOpenSearch(bool);
  };
  const toggleDrawer = (open) => {
    setOpenDrawer(open);
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (openSearch) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [openSearch]);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          padding: 0,
          bgcolor: deepOrange[500],
          background:
            "linear-gradient(90deg, rgba(255,87,34,1) 0%, rgba(255,128,72,1) 50%, rgba(255,87,34,1) 100%)",
          boxShadow:
            "0 6px 18px rgba(255,87,34,0.35), 0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <Toolbar
          component={Container}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <IconButton
            color="inherit"
            sx={{
              display: "flex",
              border: "1px solid rgba(255,255,255,0.8)",
              background: "rgba(255,255,255,0.08)",
              borderRadius: 2,
              transition: "transform .2s ease, background .2s ease",
              "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              "&:focus-visible": { outline: "3px solid #111", outlineOffset: 3 },
            }}
            onClick={() => toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>

          <Avatar
            src={SainiAudiobookLogo}
            component={RouterLink}
            to="/"
            sx={{
              width: 40,
              height: 40,
              border: "2px solid rgba(255,255,255,0.9)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          />

          <Typography
            variant="h4"
            component={RouterLink}
            to="/"
            sx={{
              display: { xs: "none", md: "flex" },
              color: "white",
              textDecoration: "none",
              alignItems: "center",
              fontWeight: 800,
              letterSpacing: 1.2,
            }}
          >
            SAINIAUDIOBOOKS
          </Typography>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
            }}
          >
            <Link
              component={RouterLink}
              to="https://www.facebook.com/PunjabiwithDkSaini/"
              color="inherit"
              sx={{
                textDecoration: "none",
                border: "1px solid rgba(255,255,255,0.8)",
                borderRadius: "100%",
                background: "rgba(255,255,255,0.08)",
                transition: "transform .2s ease, background .2s ease",
                "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              }}
            >
              <IconButton color="inherit">
                <Facebook />
              </IconButton>
            </Link>

            <Link
              component={RouterLink}
              to="https://twitter.com/devinderKaurSa2"
              color="inherit"
              sx={{
                textDecoration: "none",
                border: "1px solid rgba(255,255,255,0.8)",
                borderRadius: "100%",
                background: "rgba(255,255,255,0.08)",
                transition: "transform .2s ease, background .2s ease",
                "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              }}
            >
              <IconButton
                color="inherit"
                sx={{ "&:hover": { transform: "scale(1.05)" } }}
              >
                <Twitter />
              </IconButton>
            </Link>

            <Link
              component={RouterLink}
              to="https://www.instagram.com/devinderksaini/"
              color="inherit"
              sx={{
                textDecoration: "none",
                border: "1px solid rgba(255,255,255,0.8)",
                borderRadius: "100%",
                background: "rgba(255,255,255,0.08)",
                transition: "transform .2s ease, background .2s ease",
                "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              }}
            >
              <IconButton
                color="inherit"
                sx={{ "&:hover": { transform: "scale(1.05)" } }}
              >
                <Instagram />
              </IconButton>
            </Link>

            <Link
              component={RouterLink}
              to="https://www.youtube.com/@PunjabiAudiobooksByDKSaini"
              color="inherit"
              sx={{
                textDecoration: "none",
                border: "1px solid rgba(255,255,255,0.8)",
                borderRadius: "100%",
                background: "rgba(255,255,255,0.08)",
                transition: "transform .2s ease, background .2s ease",
                "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              }}
            >
              <IconButton
                color="inherit"
                sx={{ "&:hover": { transform: "scale(1.05)" } }}
              >
                <YouTube />
              </IconButton>
            </Link>
          </Box>

          {/* <IconButton
            color="inherit"
            onClick={() => handleSearchOpenState(true)}
            sx={{ "&:hover": { transform: "scale(1.1)" } }}
          >
            <Search />
          </IconButton> */}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={() => toggleDrawer(false)}
      >
        <Box
          sx={{
            width: { xs: "80vw", md: "20vw" },
            height: "100vh",
            display: "flex",
            backgroundColor: "#fffbf3",
          }}
          role="presentation"
          onClick={() => toggleDrawer(false)}
        >
          <Box
            flex={2}
            bgcolor="#252525"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Avatar
              src={SainiAudiobookLogo}
              component={RouterLink}
              to="/"
              sx={{
                marginTop: 1,
                width: 52,
                height: 52,
                border: "2px solid white",
                boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
              }}
            />
            <Stack height="100%" justifyContent="flex-end">
              <Link
                component={RouterLink}
                to="https://www.facebook.com/PunjabiwithDkSaini/"
              >
                <IconButton
                  sx={{
                    color: "#1877F2",
                    bgcolor: "white",
                    borderRadius: 0,
                    margin: 2,
                    "&:hover": {
                      bgcolor: "#f0f0f0",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <Facebook />
                </IconButton>
              </Link>
              <Link
                component={RouterLink}
                to="https://twitter.com/devinderKaurSa2"
              >
                <IconButton
                  sx={{
                    color: "#1DA1F2",
                    bgcolor: "white",
                    borderRadius: 0,
                    margin: 2,
                    "&:hover": {
                      bgcolor: "#f0f0f0",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <Twitter />
                </IconButton>
              </Link>
              <Link
                component={RouterLink}
                to="https://www.youtube.com/@PunjabiAudiobooksByDKSaini"
              >
                <IconButton
                  sx={{
                    color: "#FF0000",
                    bgcolor: "white",
                    borderRadius: 0,
                    margin: 2,
                    "&:hover": {
                      bgcolor: "#f0f0f0",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <YouTube />
                </IconButton>
              </Link>
              <Link
                component={RouterLink}
                to="https://www.instagram.com/devinderksaini"
              >
                <IconButton
                  sx={{
                    color: "#FF0000",
                    bgcolor: "white",
                    borderRadius: 0,
                    margin: 2,
                    "&:hover": {
                      bgcolor: "#f0f0f0",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <Instagram />
                </IconButton>
              </Link>
            </Stack>
          </Box>

          <Box flex={8}>
            <List>
              <Link
                component={RouterLink}
                to="/"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="HOME" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Divider />
              <Link
                component={RouterLink}
                to="/library"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="LIBRARY" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Divider />
              <Link
                component={RouterLink}
                to="/authors"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="BOOKS BY AUTHORS" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Divider />

              {/* Legal & Policies Section */}
              <Typography
                variant="subtitle2"
                sx={{ px: 2, pt: 2, pb: 1, color: "text.secondary", fontWeight: 600 }}
              >
                LEGAL & POLICIES
              </Typography>
              <Link
                component={RouterLink}
                to="/privacy-policy"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Privacy Policy" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link
                component={RouterLink}
                to="/terms-and-conditions"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Terms & Conditions" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link
                component={RouterLink}
                to="/refund-policy"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Refund Policy" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link
                component={RouterLink}
                to="/account-deletion"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Account Deletion" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link
                component={RouterLink}
                to="/content-policy"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Content Policy" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link
                component={RouterLink}
                to="/subscription-policy"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Subscription Policy" />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Divider sx={{ mt: 2 }} />
            </List>
          </Box>
          <IconButton
            color="inherit"
            sx={{
              marginTop: 1,
              width: 50,
              height: 50,
              border: "2px solid white",
              bgcolor: "transparent",
              transition: "transform .2s ease, background .2s ease",
              "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.1)" },
              "&:focus-visible": { outline: "3px solid #111", outlineOffset: 3 },
            }}
            onClick={() => toggleDrawer(false)}
          >
            <HighlightOff sx={{ width: 45, height: 45 }} />
          </IconButton>
        </Box>
      </Drawer>

      <Dialog
        open={openSearch}
        onClose={() => handleSearchOpenState(false)}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="scroll-dialog-description">
            {[...new Array(50)]
              .map(
                () =>
                  `Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.`
              )
              .join("\n")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleSearchOpenState(false)}>Cancel</Button>
          {/* <Button onClick={handleClose}>Subscribe</Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Navbar;